import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { NgTemplateAssertType } from '@core/common-legacy';
import { injectTellentNavigationController } from '@core/tellent-logic';
import {
  TellentNavigationGroup,
  TellentNavigationItem,
  TellentNavigationLink,
  TellentNavigationSection,
  TellentNavigationSeparator,
} from '@core/tellent-types';
import { findFirstLink } from '@core/tellent-util';
import { WalkthroughStepId } from '@core/walkthrough-types';
import { WalkthroughStepOriginDirective } from '@core/walkthrough-ui';

import { TellentNavigationGroupComponent } from './navigation-group/navigation-group.component';
import { NavigationItemPathPipe } from './navigation-item-url/navigation-item-url.pipe';
import { TellentNavigationLinkComponent } from './navigation-link/navigation-link.component';
import { TellentNavigationSeparatorComponent } from './navigation-separator/navigation-separator.component';

@Component({
  standalone: true,
  selector: 'tlc-navigation',
  styleUrls: ['./navigation.vars.less', './navigation.component.less'],
  templateUrl: './navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TellentNavigationLinkComponent,
    TellentNavigationGroupComponent,
    TellentNavigationSeparatorComponent,
    NgTemplateOutlet,
    NgTemplateAssertType,
    NavigationItemPathPipe,
  ],
  host: {
    '[class.minimized]': 'controller.minimized()',
  },
  hostDirectives: [
    {
      directive: WalkthroughStepOriginDirective,
      inputs: ['rtWalkthroughOriginStepId: walkthroughId'],
    },
  ],
})
export class TellentNavigationComponent {
  protected readonly findFirstLink = findFirstLink;

  public controller = injectTellentNavigationController();
  public itemClick = output<TellentNavigationLink>();

  public walkthroughId = input<WalkthroughStepId>();

  protected NavItemTemplateItemsContext: {
    $implicit: TellentNavigationItem[];
    group: TellentNavigationGroup | undefined;
  };

  protected NavItemTemplateLinkContext: {
    $implicit: TellentNavigationLink;
    group: TellentNavigationGroup | undefined;
  };

  protected NavItemTemplateGroupContext: {
    $implicit: TellentNavigationGroup;
    group: TellentNavigationGroup | undefined;
  };

  protected NavItemTemplateSectionContext: {
    $implicit: TellentNavigationSection;
    group: undefined;
  };

  protected NavItemTemplateSeparatorContext: {
    $implicit: TellentNavigationSeparator;
    group: TellentNavigationGroup | undefined;
  };

  public ngOnInit() {
    this.itemClick.subscribe(({ handler, path, page }) => {
      this.controller.handleNavigationLinkClick(path);
    });
  }

  public onNavigationGroupClick(group: TellentNavigationGroup) {
    this.controller.setUserSelectedGroup(group);
  }

  public onNavigationLinkClick(item?: TellentNavigationLink, group?: TellentNavigationGroup) {
    if (!item) return;
    if (!group) this.controller.clearUserSelectedGroup();

    this.itemClick.emit(item);
  }
}
